import React from 'react';
import FieldFeedback from '../../components/@base/FieldFeedback';
import style from './ComponentConfigurations.module.css';

/**
 * Título do componente
 * @param {*} props
 * @returns
 */
export function ComponentConfigurationTitleInput(props) {
  /** Manipula mudança do valor do input titulo do componente */
  const titleChangeHandle = (event) => {
    const { value } = event.target;
    props.setState((prevState) => (
      {
        component: {
          ...prevState.component,
          label: value,
        },
      }
    ));
  };

  const getTitleValidation = () => {
    let invalidMessage = null;
    if (props.component.label.trim().length === 0) {
      invalidMessage = 'Preenchimento obrigatório';
    }

    if (props.component.labelFromBackend !== props.component.label.trim()
      && props.componentsListNames.includes(props.component.label.trim())) {
      invalidMessage = 'Esse nome já é utilizado em outro componente';
    }

    const valid = !invalidMessage;
    if (props.titleIsValid !== valid) {
      props.setState({ titleIsValid: valid });
    }

    if (!valid) {
      return (
        <FieldFeedback
          invalid
          message={invalidMessage}
        />
      );
    }

    return null;
  };

  if (!props) return null;
  return (
    <div className={style.Title}>
      <input
        type="text"
        value={props.label}
        onChange={titleChangeHandle}
        maxLength="20"
        disabled={props.component.notAllowedChangeTitle}
      />
      {getTitleValidation()}
    </div>
  );
}

export default ComponentConfigurationTitleInput;
